var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInPerson = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2.429a5.456 5.456 0 0 0-5.45 5.45C4.3 11.966 9.75 18 9.75 18S15.2 11.966 15.2 7.88a5.456 5.456 0 0 0-5.45-5.45Zm0 1.557a1.557 1.557 0 1 1 0 3.115 1.557 1.557 0 0 1 0-3.115Zm0 7.786c-1.3 0-2.445-.662-3.114-1.674C6.65 9.07 8.715 8.502 9.75 8.502c1.036 0 3.099.568 3.114 1.596a3.723 3.723 0 0 1-3.114 1.674Z"
  })));
};
export { SvgInPerson as ReactComponent };